import React from 'react';

const StatusBadge = ({ status, label }) => {
  const normalizedStatus = (status || '').toLowerCase();
  
  let bgStyle = 'bg-[#27272A]/50 text-[#9CA3AF] border-[#27272A]';
  
  if (['approved', 'connected', 'completed', 'active', 'success'].includes(normalizedStatus)) {
    bgStyle = 'bg-[#10B981]/15 text-[#10B981] border-[#10B981]/30 font-semibold';
  } else if (['pending', 'processing', 'reviewing'].includes(normalizedStatus)) {
    bgStyle = 'bg-[#F59E0B]/15 text-[#F59E0B] border-[#F59E0B]/30 font-semibold';
  } else if (['rejected', 'disabled', 'failed', 'cancelled'].includes(normalizedStatus)) {
    bgStyle = 'bg-[#EF4444]/15 text-[#EF4444] border-[#EF4444]/30 font-semibold';
  }

  const displayLabel = label || status || 'Unknown';

  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs ${bgStyle}`}>
      <span className={`w-1.5 h-1.5 mr-1.5 rounded-full ${
        ['approved', 'connected', 'completed', 'active'].includes(normalizedStatus) ? 'bg-[#10B981]' :
        ['pending', 'processing'].includes(normalizedStatus) ? 'bg-[#F59E0B]' :
        ['rejected', 'disabled', 'failed'].includes(normalizedStatus) ? 'bg-[#EF4444]' : 'bg-[#9CA3AF]'
      }`} />
      {displayLabel.toUpperCase()}
    </span>
  );
};

export default StatusBadge;
